export default __webpack_public_path__ + "static/media/maintenance-bg.7c0d0707.png";